import { Col, Container, Row } from '@paypalcorp/pp-react'
import { get } from 'lodash'
import React, { useEffect } from 'react'

import Layout from 'components/Layout'

import clientData, { init as initClientData } from '../../../lib/client-data'
import { setupPa } from '../../../lib/track-client-side'
import {
  SHOPPING_CASHBACK_TERMS_SCREEN_SHOWN,
  DASHBOARD_MODULE
} from '../../../lib/client-constants'

initClientData()

type RewardsTermsAndConditionsData = {
  title?: string
  subtitle?: string
  description?: string
} | null

export const RewardsTermsAndConditions = () => {
  const data = get(
    clientData,
    'rewardsTermsData.ppshopping_gold_terms.content',
    null
  ) as RewardsTermsAndConditionsData
  useEffect(() => {
    setupPa(DASHBOARD_MODULE, SHOPPING_CASHBACK_TERMS_SCREEN_SHOWN, {})
  }, [])

  if (!data) {
    return null
  }

  return (
    <Layout>
      <Container as="main" className="rewards-terms-and-conditions">
        <Row className="rewards-terms-and-conditions__container">
          <Col>
            {data && (
              <section>
                <div
                  className="rewards-terms-and-conditions__title"
                  dangerouslySetInnerHTML={{ __html: data.title || '' }}
                />
                <div
                  dangerouslySetInnerHTML={{ __html: data.subtitle || '' }}
                />
                <div
                  dangerouslySetInnerHTML={{ __html: data.description || '' }}
                />
              </section>
            )}
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}
